export default __webpack_public_path__ + "static/media/Flow.292b14ba.svg";